export const themeOptions = [
    { value: 'vs-dark', label: 'VsCode Dark' },
    { value: 'vs', label: 'VsCode Light' },
    { value: 'light', label: 'Light' },
    { value: 'hc-black', label: 'High Contrast' },
]